import Vue from 'vue'
import moment from 'moment'
import { Popover, Spin, LocaleProvider, Select, Radio, Checkbox, message, Modal, Tooltip, Empty, Divider } from 'ant-design-vue'
import FlightSearchBar from '@/components/flightsearchbar'
import '@/components/l8-icon'
import './css/index.less'

Vue.use(Popover)
Vue.use(Spin)
Vue.use(LocaleProvider)
Vue.use(Select)
Vue.use(Radio)
Vue.use(Checkbox)
Vue.use(Modal)
Vue.use(Tooltip)
Vue.use(Empty)
Vue.use(Divider)
Vue.prototype.$message = message
Vue.prototype.$error = Modal.error
Vue.prototype.$confirm = Modal.confirm
Vue.prototype.$info = Modal.info
Vue.use(FlightSearchBar)
Vue.config.productionTip = false

Vue.filter('discount', (val) => {
  const value = parseFloat(val)

  if (isNaN(parseFloat(value))) {
    return '-'
  }

  return value >= 1 ? '全价' : `${(value * 10).toFixed(1)}折`
})

Vue.filter('duration', ({ departureDate, departureTime, arrivalDate, arrivalTime }) => {
  if (departureDate && departureTime && arrivalDate && arrivalTime) {
    return getDuration(departureDate, departureTime, arrivalDate, arrivalTime, 'eng')
  } else {
    return '-'
  }
})

Vue.filter('transferDuration', (orgDsts) => {
  const { arrivalDate: departureDate, arrivalTime: departureTime } = orgDsts[0]
  const { departureDate: arrivalDate, departureTime: arrivalTime } = orgDsts[1]

  if (departureDate && departureTime && arrivalDate && arrivalTime) {
    return getDuration(departureDate, departureTime, arrivalDate, arrivalTime)
  } else {
    return '-'
  }
})

Vue.filter('transferDurationSimple', (value) => {
  if (value) {
    const duration = moment.duration(value, 'minutes')
    const d = duration.days()
    const h = duration.hours()
    const m = duration.minutes()
    return `${d ? d + 'd' : ''} ${h}h ${m}m`
  } else {
    return '-'
  }
})

Vue.filter('transferDurationTotal', (value = {}, extra = []) => {
  let time = 0
  if (extra.length > 0) {
    for (let index = 0; index < extra.length; index++) {
      if (extra[index].transferDuration) {
        const start = moment(extra[index].transferDuration.departureDate + ' ' + extra[index].transferDuration.departureTime).format('x')
        const end = moment(extra[index].transferDuration.arrivalDate + ' ' + extra[index].transferDuration.arrivalTime).format('x')
        time += Number(Math.floor((end - start) / (60 * 1000)))
      }
    }
  }
  if (value.flightInfos?.length > 0) {
    for (let index = 0; index < value?.flightInfos?.length; index++) {
      const item = value?.flightInfos?.[index]
      time += Number(item.duration)
    }
  }
  if (value || extra) {
    const duration = moment.duration(time, 'minutes')
    const d = duration.days()
    const h = duration.hours()
    const m = duration.minutes()
    return `${d ? d + 'd' : ''} ${h}h ${m}m`
  } else {
    return '-'
  }
})

Vue.filter('getTime', (value) => {
  if (!value) {
    return '-'
  }

  value = value.split(':')

  return value.splice(0, 2).join(':')
})

// +1
Vue.filter('gtDay', (flight) => {
  if (!flight) {
    return
  }

  let start = new Date(flight.departureDate).getTime()
  let end = new Date(flight.arrivalDate).getTime()
  const gt = Math.floor((end - start) / (24 * 3600 * 1000))
  return gt ? `${gt > 0 ? '+' + gt : gt}天` : ''
})

// +1
Vue.filter('gtDayForTransfer', (departureDate, arrivalDate) => {
  if (!departureDate || !arrivalDate) {
    return
  }

  let start = new Date(departureDate).getTime()
  let end = new Date(arrivalDate).getTime()
  const gt = Math.floor((end - start) / (24 * 3600 * 1000))
  return gt ? `${gt > 0 ? '+' + gt : gt}天` : ''
})

Vue.filter('stopCity', (value) => {
  if (!value) {
    return '-'
  }

  return value.map(item => item.stopAirportName + (item.stopCityTerm ?? '')).join(',')
})

Vue.filter('ruleFee', (value, txt = '-') => {
  if (!value) {
    return txt
  }

  let val = value - 0

  if (isNaN(val)) {
    return value
  }

  if (val > 0) {
    return val + '元/人'
  }

  return txt
})

Vue.filter('priceTag', (service, labelPrices, property) => {
  const priceTag = labelPrices.find(item => { return item.code === service.productCode }) || {}
  return priceTag[property] || ''
})

Vue.filter('getInventory', (value) => {
  if (!value) {
    return '-'
  }

  return value >= 10 ? '余票充足' : '仅剩' + value + '张'
})

function getDuration (departureDate, departureTime, arrivalDate, arrivalTime, languge = 'zh') {
  const time1 = new Date(`${departureDate} ${departureTime}`.replace(/-/g, '/')).getTime()
  const time2 = new Date(`${arrivalDate} ${arrivalTime}`.replace(/-/g, '/')).getTime()
  const duration = time2 - time1
  const day = Math.floor(duration / (24 * 3600 * 1000))
  const hour = Math.floor(duration / (3600 * 1000))
  const second = Math.ceil((duration - hour * 3600 * 1000) / 60000)
  let txt = `${hour}${languge === 'zh' ? '小时' : 'h'} ${second}${languge === 'zh' ? '分钟' : 'm'}`

  if (day) {
    txt = `${day}${languge === 'zh' ? '天' : 'd'} ${txt}`
  }

  return txt
}
